export class Co2Total {
  cnpjCli: string;
  idUsuario: string;
  co2: number;
  indicEcofrete: boolean;
}
